﻿import { useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Row, Col, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";

import Head from "@/components/Content/Head";
import BasePagination from "@/components/Pagination/BasePagination";
import Fetching from "@/components/Fetching/Fetching";
import VersionsTableHead from "./VersionsTableHead";
import VersionsTableBody from "./VersionsTableBody";
import BasicConfirm from "@/components/Confirm/BasicConfirm";
import VersionsForm from "./VersionsForm/VersionsForm";
import classes from "../maintainers.module.scss";

import { useVersionsPaginate, useMutateVersion, useMutateDeleteVersion } from "@/hooks/maintainers/versions";
import { base_list } from "./versions.constants";

const Versions = () => {
	const { addToast } = useToasts();
	const { search } = useSelector((state) => state.auth.filter);
	const { option } = useParams();
	const navigate = useNavigate();

	const [base, setBase] = useState({ ...base_list });
	const [showDelete, setShowDelete] = useState(false);
	const [selected, setSelected] = useState("");

	const { data, isLoading, isFetching } = useVersionsPaginate({
		...base,
		search,
	});
	const { mutate: mutateSave, isLoading: isLoadingSave } = useMutateVersion({
		...base,
		search,
	});
	const { mutate: mutateDelete, isLoading: isLoadingDelete } = useMutateDeleteVersion({
		...base,
		search,
	});

	const { versions: list } = data ? data : {};
	const { customers } = data ? data : {};
	const { data: versions, last_page, total, from, to } = list ? list : {};

	const handleDelete = (item) => {
		setSelected(item.id);
		setShowDelete(true);
	};

	const confirmDelete = () => {
		mutateDelete(
			{ ...base, search, selected },
			{
				onSuccess: () => {
					setSelected("");
					setShowDelete(false);
					addToast("Versión eliminada correctamente.", {
						appearance: "success",
					});
				},
			},
		);
	};

	const confirmSave = (data) => {
		mutateSave(
			{ ...base, search, params: { ...data } },
			{
				onSuccess: () => {
					addToast("Versión guardada correctamente.", {
						appearance: "success",
					});
				},
			},
		);
	};

	const setPage = (value) => setBase({ ...base, page: value });
	const setOrder = (value) => setBase({ ...base, order: value });
	const setOrderType = (value) => setBase({ ...base, orderType: value });
	const setPaginate = (value) => setBase({ ...base, paginate: value });

	if (isLoading || isLoadingDelete) {
		return <Fetching />;
	}

	return (
		<>
			<Head
				title="Versiones"
				button={true}
				button_text={"Nueva Versión"}
				action={() => navigate("/mantenedores/versiones/crear")}
				back_url={"/mantenedores"}
				isFetching={isFetching}
			/>

			<Row className={` ${classes.main_row}`}>
				<Col md={12} className={classes.main_col}>
					<Row className={classes.table}>
						<div className={classes.table_div}>
							<Table className={classes.table_desktop}>
								<VersionsTableHead order={base.order} setOrder={setOrder} orderType={base.orderType} setOrderType={setOrderType} />

								<VersionsTableBody versions={versions} handleDelete={handleDelete} />
							</Table>
						</div>
					</Row>

					<BasePagination
						page={base.page}
						paginate={base.paginate}
						last_page={last_page}
						quantity={total}
						from={from}
						to={to}
						setPage={setPage}
						setPaginate={setPaginate}
					/>
				</Col>
			</Row>

			<BasicConfirm
				showConfirm={showDelete}
				setShowConfirm={setShowDelete}
				handleAction={confirmDelete}
				showValidation={true}
				textValidation={"eliminar version"}
			/>

			{option && <VersionsForm confirmSave={confirmSave} isLoadingSave={isLoadingSave} customers={customers} />}
		</>
	);
};

export default Versions;
